import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

// Print e logo são servidos pelo quarkus.
const authHeader = () => ({ headers: { Authorization: sessionStorage.getItem('token') } });

export function useTreatmentPrint() {
  const [treatmentToPrint, setTreatmentToPrint] = useState('');
  const [logo, setLogo] = useState(null);

  const fetchTreatmentToPrint = useCallback((treatmentId) => {
    return quarkusApi
      .get(`/patients/null/treatments/${treatmentId}/print`, authHeader())
      .then((returnFromApi) => setTreatmentToPrint(returnFromApi.data))
      .catch((returnFromApi) => console.error('ops! ocorreu um erro' + returnFromApi));
  }, []);

  const fetchLogo = useCallback(() => {
    return quarkusApi
      .get('/clinic/logo', authHeader())
      .then((returnFromApi) => setLogo(returnFromApi.data))
      .catch(() => {});
  }, []);

  return { treatmentToPrint, logo, fetchTreatmentToPrint, fetchLogo };
}
